module.exports = __webpack_public_path__ + "img/github_h.7fc0143b.svg";